var map = {
	"./modules/about/about.module": "./src/app/modules/about/about.module.ts",
	"./modules/award/award.module": "./src/app/modules/award/award.module.ts",
	"./modules/beyond/beyond.module": "./src/app/modules/beyond/beyond.module.ts",
	"./modules/blogs/blogs.module": "./src/app/modules/blogs/blogs.module.ts",
	"./modules/contact/contact.module": "./src/app/modules/contact/contact.module.ts",
	"./modules/gallery/gallery.module": "./src/app/modules/gallery/gallery.module.ts",
	"./modules/infrastructure/infrastructure.module": "./src/app/modules/infrastructure/infrastructure.module.ts",
	"./modules/mandatory/mandatory.module": "./src/app/modules/mandatory/mandatory.module.ts",
	"./modules/staff/staff.module": "./src/app/modules/staff/staff.module.ts",
	"./modules/tiny/tiny.module": "./src/app/modules/tiny/tiny.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;